<template>
  <v-app>
    <v-main>
      <MedicoHeader v-if="!$route.meta.hideHeader" />
      <v-snackbar v-model="snackbar" :color="color" :timeout="6000" multi-line top>
        <v-container class="ma-0 pa-0">
          <v-row justify="space-between" align="center">
            <v-col class="font-weight-bold">
              {{ text }}
            </v-col>
            <v-col cols="auto" class="mr-1">
              <v-btn class="text-none" text @click.stop="snackbar = false"> FECHAR </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-snackbar>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue'
import MedicoHeader from '@/components/Layout/MedicoHeader.vue'
import authService from '@/services/auth'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'App',
  data: () => ({
    snackbar: false,
    text: '',
    color: '',
    timeout: 3000,
  }),
  components: {
    MedicoHeader,
  },
  methods: {
    ...mapGetters('medico', { medico: 'medico' }),
    isAuthenticated() {
      return authService.getToken()
    },
    setDatadogUser() {
      if (this.isAuthenticated()) {
        const medico = this.medico()
        this.$setDatadogUser(medico.id.toString(), medico.nome, medico.email)
      }
    },
  },
  created() {
    this.$initDatadog()
    this.setDatadogUser()
    this.$root.$on('snackbar', (text: string, color: 'error' | 'success' | 'info') => {
      this.text = text
      this.color = color
      this.timeout = 3000
      this.snackbar = true
    })
  },
})
</script>
